<div class="close-icon" *ngIf="data.config.closeable">
  <svg-icon appDialogClose key="close"></svg-icon>
</div>
<div class="dialog-container" [class.shadow]="isPopupDialog" [class.new-message]="isNewMessageDialog">
  <div appInfiniteScroll class="dialog-content" [class.p-0]="isPopupDialog || isNewMessageDialog" (scrollEnd)="onScrollEnd()">
    <ng-template cdkPortalOutlet></ng-template>
  </div>
</div>
